import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import Icon from '../icons/Icon';
import fileSizeLessThan from '../../common/utils/fileSizeLessThan';

class VideoUploader extends Component {
  static propTypes = {
    onVideoUpload: PropTypes.func.isRequired,
    uploading: PropTypes.bool,
    uploadProgress: PropTypes.object,
    video: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  };

  static defaultProps = {
    uploading: false,
    uploadProgress: { loaded: 0, total: 100 },
    video: false,
  };

  state = {
    videoError: null,
  };

  onDrop = files => {
    const fileSizeValidation = fileSizeLessThan(1073741824)(files);

    if (fileSizeValidation.isValid) {
      this.setState({
        videoError: null,
      });
      this.props.onVideoUpload(files);
    } else {
      if (!fileSizeValidation.isValid) {
        this.setState({
          videoError: fileSizeValidation.message,
        });
      }
    }
  };

  render() {
    const { uploading, uploadProgress, video } = this.props;

    const { videoError } = this.state;

    if (uploading) {
      return (
        <div className="input-scaffold cropper-scaffold">
          <div className="image-cropper">
            <div>Upload Progress: {`${parseInt(100 * uploadProgress.loaded / uploadProgress.total, 10)}%`}</div>
          </div>
        </div>
      );
    }

    let videoText = (
      <div className="dropzone__info">
        <Icon icon="VideoUpload" />
        <h4>Drag video here or click to browse</h4>
        <p>Max file size: 1GB</p>
      </div>
    );

    if (video) {
      videoText = (
        <div className="dropzone__video dropzone__info">
          <Icon icon="VideoUpload" />
          Your swing has been uploaded. Someone at Tathata will review it very soon!
        </div>
      );
    }

    return (
      <div className="input-scaffold cropper-scaffold">
        <div className="image-cropper">
          <Dropzone className="dropzone" activeClassName="dropzone--active" onDrop={this.onDrop}>
            {videoText}
          </Dropzone>
        </div>
        {videoError ? <div className="input-validation">{videoError}</div> : null}
      </div>
    );
  }
}

export default VideoUploader;



// WEBPACK FOOTER //
// ./src/common/components/VideoUploader.js